<template>
  <div class="login-modal-box">
    <van-dialog 
      v-model="visible" 
      title="微信授权登录"
      confirm-button-color="#1dad18"
      cancel-button-color="#8d8d8d"
      confirmButtonText="允许"
      cancelButtonText="拒绝"
      @confirm="confirmLogin"
      @cancel="cancel"
      show-cancel-button>
      <div class="login-modal-content">
        <div class="logo-box">
          <img :src="require('@/assets/images/weChat.png')" class="logo" />
        </div>
        <div class="content-title">
          {{user.orgTitle}}申请获得以下权限
        </div>
        <div class="content-text">
          <span class="icon-dian"></span> 获得你的公开信息（昵称、头像）等
        </div>
      </div>
    </van-dialog> 
  </div>
</template>
<script>
import {mapState} from "vuex";
export default {
  name: "LoginModal",
  computed:{
    ...mapState(['user'])
  },
  mounted(){
  },
  data () {
    return {
      visible:false
    }
  },
  methods: {
    showModal() {
      this.visible=!this.visible
    },
    control(){
      this.visible=!this.visible
    },
    confirmLogin() {
      let initData= {
        loginType:this.loginType,
        deviceNum:this.deviceNum
      }
      this.$api.login.loginInit(initData).then(res => {
        if(res.code==200){
          let redirect_uri = encodeURIComponent(res.redirect_uri), appid = res.appId
          this.goThere(this.loginType,appid,redirect_uri)
        }else{
          this.$router.push({name: 'nonsupport'})
        }
      })
    },
    goThere(loginType,appid,redirect_uri){
        if(loginType==2){
            window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appid + "&redirect_uri=" + redirect_uri + "&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect"
        }else if(loginType==1){
            window.location.href = "https://openauth.alipay.com/oauth2/publicAppAuthorize.htm?app_id="+appid+"&scope=auth_user&redirect_uri="+redirect_uri
        }
    },
    cancel(){
        this.$emit("cancelEvent");
    }
  }
}
</script>
<style  lang='scss' scoped>
.login-modal-box{
  .van-dialog{
    width: calc(100% - 100px);
    border-radius: 20px;
    ::v-deep.van-dialog__content{
      border-bottom: 1px solid #ccc;
    }
    ::v-deep.van-dialog__cancel{
      border-right: 1px solid #ccc;
    }
    ::v-deep.van-dialog__header{
      padding-top: 0;
      line-height: 100px;
      font-size: 34px;
      border-bottom: 1px solid #ccc;
    }
  }
}
.login-modal-content{
  border-top: #8d8d8d;
  text-align: center;
  padding: 30px 40px;
}
.login-modal-content .logo-box{
  width: 80px;
  height: 80px;
  border-radius: 50%;
  overflow: hidden;
  display: inline-block;
} 
.login-modal-content .logo{
  width: 80px;
  height: 80px;
}
.login-modal-content .content-title{
  text-align: left;
  color: #000;
  font-size: 32px;
  line-height: 80px;
  width: 100%;
} 
.login-modal-content .content-text{
  text-align: left;
  color: #9d9d9d;
  font-size: 26px;
  line-height:  80px;
  display: flex;
  align-items: center;
}
.login-modal-content .icon-dian{
  width: 15px;
  height: 15px;
  display: block;
  border-radius: 50%;
  background-color: #9d9d9d;
  margin-right: 20px;
}
</style>